module.exports = __webpack_public_path__ + "media/images/home/docenti02-aa0680bfabd76142b16473242b90fd34.svg";